{
  "consonants": [
    "क",
    "ख",
    "ग",
    "घ",
    "ङ",
    "च",
    "छ",
    "ज",
    "झ",
    "ञ",
    "ट",
    "ठ",
    "ड",
    "ढ",
    "ण",
    "त",
    "थ",
    "द",
    "ध",
    "न",
    "प",
    "फ",
    "ब",
    "भ",
    "म",
    "य",
    "र",
    "ल",
    "व",
    "श",
    "ष",
    "स",
    "ह",
    "ळ"
  ],
  "vowelsIndependent": [
    "अ",
    "आ",
    "इ",
    "ई",
    "उ",
    "ऊ",
    "ऋ",
    "ॠ",
    "ऌ",
    "ॡ",
    "ए",
    "ऐ",
    "ओ",
    "औ",
    "ॲ",
    "ऑ"
  ],
  "vowelMatras": [
    "ा",
    "ि",
    "ी",
    "ु",
    "ू",
    "ृ",
    "ॄ",
    "ॢ",
    "ॣ",
    "े",
    "ै",
    "ो",
    "ौ",
    "ॅ",
    "ॉ"
  ],
  "halant": "्",
  "digits": ["०", "१", "२", "३", "४", "५", "६", "७", "८", "९"],
  "marks": {
    "anusvara": "ं",
    "chandrabindu": "ँ",
    "visarga": "ः"
  }
}
